import gql from 'graphql-tag'
export default gql`query familyQuery($id: Int!) {
  family(id: $id) {
    name
    id
  }
}`